import axios from 'axios'
import { smrApi } from '@/utils/axios-config';

const apiBase = 'gis-location';

const CancelToken = axios.CancelToken;
let source;

export default {
    getLocation(term) {
        if(source) {
            source.cancel('New location request initiated');
        }
        source = CancelToken.source();
        return smrApi.get(`${apiBase}/location/search`, {
            params: {
                term
            },
            cancelToken: source.token
        })
    },

    getClosestLocation(lng, lat) {
        if(source) {
            source.cancel('New nearby location request initiated');
        }
        source = CancelToken.source();
        return smrApi.get(`${apiBase}/location/nearby`, {
            params: {
                lat: lat,
                lon: lng,
                radius: 1,
                count: 1,
                type: 'GEO_STREET'
            },
            cancelToken: source.token
        })
    }
}